define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/form/Form"
], function(declare,_TemplatedMixin,_WidgetsInTemplateMixin,Form) {

	return declare([Form, _TemplatedMixin, _WidgetsInTemplateMixin], {
	});
});